var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfilledStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0219 8.68038L11.3805 9.02886L11.0219 8.68038C10.8058 8.90274 10.7051 9.21277 10.7492 9.51969L11.2786 13.2008L7.94125 11.5598C7.66299 11.423 7.33701 11.423 7.05875 11.5598L3.72142 13.2008L4.25079 9.51969C4.29493 9.21277 4.19419 8.90274 3.97809 8.68038L3.61953 9.02886L3.97809 8.68038L1.38612 6.01348L5.05063 5.37943C5.35617 5.32656 5.61989 5.13495 5.76459 4.86071L7.5 1.57149L9.23541 4.86071C9.38011 5.13496 9.64383 5.32656 9.94937 5.37943L13.6139 6.01348L11.0219 8.68038Z",
    stroke: "#0B5CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledStar);
export default __webpack_public_path__ + "static/media/unfilledStar.5672ba8f2a172d73f2fcb64a126e4d52.svg";
export { ForwardRef as ReactComponent };